module.exports = __webpack_public_path__ + "img/welcome.b02f0709.svg";